<div
  #toastContainer
  class="bg-white dark:bg-dark-card pointer-events-auto w-96 min-h-14 rounded-lg shadow-sm border border-gray-medium dark:border-dark-border animate-fadeinright overflow-hidden duration-300 hover:bg-gray-100 dark:hover:bg-dark-hover cursor-pointer transition-all ease-in-out transform"
  (click)="close()">
  <div class="flex items-center px-4 py-4">
    <div class="mr-3">
      <div class="w-8 h-8 rounded-full flex justify-center items-center text-white"
           [ngClass]="{
           'bg-emerald-500': type === 'success',
           'bg-red-500': type === 'error',
           'bg-yellow-500': type === 'warning',
           'bg-theme-primary': type === 'info'
           }"
      >
        @switch (type) {
          @case ('success') {
            <lucide-icon size="16" [name]="Check"></lucide-icon>
          }
          @case ('error') {
            <lucide-icon size="16" [name]="X"></lucide-icon>
          }
          @case ('warning') {
            <lucide-icon size="16" [name]="CircleAlert"></lucide-icon>
          }
          @case ('info') {
            <lucide-icon size="16" [name]="Info"></lucide-icon>
          }
        }
      </div>
    </div>
    <div>
      @if (title) {
        <div class="font-medium text-primary dark:text-dark-text text-base">{{ title | translate }}</div>
      }
      @if (message) {
        <div class="text-secondary dark:text-dark-muted font-light text-sm">{{ message | translate }}</div>
      }
    </div>
  </div>

  <div class="w-full h-1">
    @if (!hovered) {
      <div class="h-full animate-fillhorizontal"
           [ngStyle]="{ 'animation-duration': duration + 'ms' }"
           [ngClass]="{
           'bg-emerald-500': type === 'success',
           'bg-red-500': type === 'error',
           'bg-yellow-500': type === 'warning',
           'bg-theme-primary': type === 'info'
             }"
      ></div>
    }
  </div>

</div>
